<template>
  <div>
    <vx-card class="mb-4">
      <SearchYear
        label="실시내역"
        :query="{ y: 'year' }"
        :options="{
          default: new Date().getFullYear(),
          afterFix: '년',
        }"
        v-model="selectedYear"
      />
    </vx-card>
    <div class="flex items-center justify-end mb-4">
      <vs-button color="secondary" type="border" @click="onClickExcelDownload">Excel 다운로드</vs-button>
    </div>
    <table>
      <colgroup>
        <col width="63" />
        <col width="200" />
        <col width="200" />
        <col width="200" />
        <col style="min-width: 500px" />
        <col width="200" />
        <col width="70" />
        <col width="70" />
      </colgroup>
      <thead>
        <tr>
          <th rowspan="2">No.</th>
          <th rowspan="2">사업장명</th>
          <th rowspan="2">승인연도</th>
          <th rowspan="2">승인 월</th>
          <th rowspan="2">승인 내역</th>
          <th rowspan="2">진행상태</th>
          <th colspan="2">위험성평가</th>
        </tr>
        <tr>
          <th>개선전</th>
          <th>개선후</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, item_i) in datas" :key="item.id">
          <td>{{ item_i + 1 }}</td>
          <td>{{ item.body.stdInfo.field_name }}</td>
          <td>{{ item.header.year }}</td>
          <td>{{ item.header.month }}월</td>
          <td class="whitespace-pre-wrap">{{ item.body.subInfo.승인내역 }}</td>
          <td class="진행상태-상정">상정</td>
          <!-- <td class="진행상태-진행">진행</td> -->
          <!-- <td class="진행상태-완료">완료</td> -->
          <td><p class="위험성평가-미완료">미완료</p></td>
          <td><p class="위험성평가-미완료">미완료</p></td>
          <!-- <td><p class="위험성평가-완료">완료</p></td> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import SearchYear from "@/views/list/components/SearchYear.vue";
import XLSX from "xlsx";

export default {
  components: { SearchYear },
  data() {
    return {
      selectedYear: "", // 초기 선택된 연도를 현재 연도로 설정
      datas: {},
    };
  },
  watch: {
    selectedYear(value) {
      this.checkMonth();
    },
  },
  created() {
    this.checkMonth();
  },
  methods: {
    onClickExcelDownload() {
      // 새로운 워크북 생성
      const wb = XLSX.utils.book_new();

      // 데이터를 추가할 워크시트 생성
      const ws_data = [
        ["No.", "사업장명", "승인연도", "승인 월", "승인 내역", "진행상태", "위험성평가", ""],
        ["", "", "", "", "", "", "개선전", "개선후"],
      ];

      this.datas.map((item, item_i) => {
        const _data = [item_i + 1, item.body.stdInfo.field_name, item.header.year, `${item.header.month}월`, item.body.subInfo.승인내역, "상정", "미완료", "미완료"];
        ws_data.push(_data);
      });

      // 워크시트 데이터 추가
      const ws = XLSX.utils.aoa_to_sheet(ws_data);

      // 병합 설정
      ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // A1:A2 병합
        { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // B1:B2 병합
        { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // C1:C2 병합
        { s: { r: 0, c: 3 }, e: { r: 1, c: 3 } }, // D1:D2 병합
        { s: { r: 0, c: 4 }, e: { r: 1, c: 4 } }, // E1:E2 병합
        { s: { r: 0, c: 5 }, e: { r: 1, c: 5 } }, // F1:F2 병합

        { s: { r: 0, c: 6 }, e: { r: 0, c: 7 } }, // D1:E1 병합
      ];

      // 워크북에 워크시트 추가
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      // 엑셀 파일 다운로드
      XLSX.writeFile(wb, `${this.selectedYear} 설비안전위원회 승인내역.xlsx`);
    },
    async checkMonth() {
      if (!this.selectedYear) return;

      const projectId = this.$route.params.proj_id;
      const boardId = this.$route.params.boardId;
      const page = 1;
      const perPage = 10000;
      const dateTarget = "body.monthDate";
      let dateBegin = `${this.selectedYear}-01-01`;
      let dateEnd = `${this.selectedYear}-12-31`;

      const conditions = [];
      conditions.push({ key: dateTarget, operator: ">=", value: dateBegin });
      conditions.push({ key: dateTarget, operator: "<=", value: dateEnd });

      await this.$store.dispatch("board/LOAD_POST_LIST", { projectId, boardId, page, perPage, conditions });
      const list = this.$store.state.board.postListInfo.data;

      let _datas = [];

      if (0 < list.length) {
        list.map((data) => {
          const filedId = data.field_id;
          const content = JSON.parse(data.post_content);
          _datas.push(content);
        });

        _datas.sort((a, b) => {
          // 1순위: field_name 정렬
          if (a.body.stdInfo.field_name < b.body.stdInfo.field_name) return -1;
          if (a.body.stdInfo.field_name > b.body.stdInfo.field_name) return 1;

          // 2순위: header.month 정렬 (숫자 정렬)
          return b.header.month - a.header.month;
        });

        this.datas = JSON.parse(JSON.stringify(_datas));
      } else {
        this.datas = {};
      }
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;

  &,
  th,
  td {
    font-size: 14px;
    text-align: center;
    background: white;
    border: 1px solid #cdcdcd;
    padding: 18px 6px;
  }

  th {
    font-weight: 500;
    background: #fafafa;
  }

  td {
    font-weight: 400;
  }
}

.진행상태-진행 {
  color: #ff9f43;
}
.진행상태-완료 {
  color: #28c76f;
}

.위험성평가-미완료 {
  display: inline-block;
  color: white;
  background: #ff9f43;
  border-radius: 4px;
  padding: 2px 7px;
  margin: auto;
}
.위험성평가-완료 {
  display: inline-block;
  color: white;
  background: #3c3c3c;
  border-radius: 4px;
  padding: 2px 7px;
  margin: auto;
}
</style>
